import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./assets/css/color.css";
import "react-modern-drawer/dist/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/globals.css";
import "./assets/css/typography.css";
import "./assets/fonts/Nunito-VariableFont_wght.ttf";
import { CustomProvider } from "./store/customProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CustomProvider>
      <App />
    </CustomProvider>
  </React.StrictMode>
);
